<template>
  <AdSenseUnit
    :ad-slot="adSlot"
    ad-format="horizontal"
    :full-width-responsive="true"
    container-class="banner"
    v-bind="$attrs"
  />
</template>

<script>
import AdSenseUnit from './AdSenseUnit.vue';

export default {
  name: 'AdSenseBanner',
  components: {
    AdSenseUnit,
  },
  inheritAttrs: false,
  props: {
    adSlot: {
      type: String,
      required: true,
    },
  },
};
</script>
